module.exports = __webpack_public_path__ + "static/media/un.cc2eb7d1.svg";